import LinkOrSpan from "@/components/links/LinkOrSpan/LinkOrSpan";
import { RowRendererProps } from "@/components/Table/Table";
import { Leg, Route } from "@/hooks/useTransport";
import { Checkbox } from "antd";
import { Fragment } from "react";
import tableStyles from "../../../components/Table/Table.module.scss";
import routeStyles from "./RouteRow.module.scss";

export interface BomRowRendererProps<R = Route | Leg> extends RowRendererProps<R> {
  level?: number;
}

export default function RouteRow({
  record,
  columns,
  activeRowKey,
  rowKey,
  selectedKeys,
  onChangeCheckbox,
  rowLink,
  onRowClick,
  gridTemplateColumns,
}: BomRowRendererProps<Route>) {
  if (!("legs" in record)) {
    return <></>;
  }

  const gridTemplateColumnsForLegs = columns
    .map((column) => {
      if (column.key === "order_id") {
        const width = 200 - 24;
        return `minmax(${width}px, ${width}px)`;
      }
      return `minmax(${column.minWidth ? column.minWidth : "150px"}, ${
        column.maxWidth ? column.maxWidth : "1fr"
      })`;
    })
    .join(" ");

  return (
    <>
      {record.legs.map((leg, index) => (
        <div
          key={index}
          style={{
            gridTemplateColumns: index === 0 ? gridTemplateColumns : gridTemplateColumnsForLegs,
            marginLeft: index > 0 ? "24px" : undefined,
          }}
          className={[
            index > 0 && routeStyles.leg,
            tableStyles.row,
            activeRowKey && activeRowKey === record[rowKey as keyof Route] && tableStyles.active,
          ].join(" ")}
        >
          {columns.map((column) => {
            const rowRecord = { ...record, ...leg };

            return (
              <Fragment key={column.key}>
                {column.type === "checkbox" && index === 0 ? (
                  <div
                    className={tableStyles.column}
                    {...column.cellProps?.(record, column.key)}
                  >
                    <div className={tableStyles.wrapper}>
                      <Checkbox
                        value={record[rowKey as keyof Route]}
                        checked={selectedKeys?.includes(record[rowKey as keyof Route])}
                        onChange={onChangeCheckbox}
                      />
                    </div>
                  </div>
                ) : (
                  <LinkOrSpan
                    onClick={() => onRowClick?.(record)}
                    to={column.noLink ? undefined : rowLink?.(record)}
                    className={[tableStyles.column, onRowClick && tableStyles.pointer].join(" ")}
                    {...column.cellProps?.(record, column.key)}
                  >
                    <div
                      className={[tableStyles.wrapper, tableStyles[column.align || "start"]].join(
                        " "
                      )}
                    >
                      {index > 0 && (column.key === "order_id" || column.key === "actions") ? (
                        <></>
                      ) : column.renderer ? (
                        column.renderer(rowRecord, column.key)
                      ) : (
                        rowRecord?.[column.key as keyof (Route | Leg)]
                      )}
                    </div>
                  </LinkOrSpan>
                )}
              </Fragment>
            );
          })}
        </div>
      ))}
    </>
  );
}
